<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <div v-if="loading" class="text-center">
          <p>Generating PDF...</p>
          <v-progress-circular indeterminate color="primary" />
        </div>

        <div v-else class="text-center">
          <p>{{ errorMessage }}</p>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { GENERATE_ASSET_LIST_MUTATION } from '../../constants/graphql/assets';

  export default {
    name: 'AssetListPdf',
    data() {
      return {
        loading: true,
        errorMessage: null,
      };
    },
    created() {
      this.generate_pdf();
    },
    methods: {
      generate_pdf() {
        const uuid = this.$route.params.id;

        this.$apollo
          .mutate({
            mutation: GENERATE_ASSET_LIST_MUTATION,
            variables: {
              uuid,
            },
          })
          .then(response => {
            window.location = response.data.generateAssetListPdf;
          })
          .catch(error => {
            this.loading = false;
            const errorMessage = error.message
              .replace('GraphQL error:', '')
              .trim();
            if (errorMessage == 'Invalid uuid') {
              this.errorMessage = 'Sorry, the token provided is invalid.';
            } else if (
              errorMessage == 'Testator does not have a valid payment plan'
            ) {
              this.errorMessage =
                'Sorry, the testator does not have an existing payment plan to be able to view their assets.';
            } else {
              this.errorMessage = 'Sorry, something went wrong.';
              throw error;
            }
          });
      },
    },
  };
</script>
